import * as React from 'react';

import { Box, Skeleton } from '@mui/material';
import { Sizes } from '../../@shared/palette';
import { FlexBoxInline } from '../../@shared/templates';


const SchemaShimmer = () => {

  return <Box sx={{ padding: "15px", width: "100%" }}>
    <Skeleton variant="text" width={250} sx={{ fontSize: Sizes.pageTitle, marginBottom: "5px" }} />
    <Skeleton variant="text" width={150} sx={{ fontSize: Sizes.textSecondary, marginBottom: "5px" }} />
    <Skeleton variant="text" width={350} sx={{ fontSize: Sizes.textSecondary, marginBottom: "30px" }} />

    <Box sx={{ ...FlexBoxInline, marginBottom: "20px", gap: 0 }}>
      <Skeleton variant="rectangular" width={100} height={50} />
      <Skeleton variant="rectangular" width={100} height={50} />
      <Skeleton variant="rectangular" width={100} height={50} />
      <Skeleton variant="rectangular" width={100} height={50} />
    </Box>

    <Skeleton variant="text" width={150} sx={{ fontSize: Sizes.textSecondary, marginBottom: "5px" }} />
    <Skeleton variant="text" width={350} sx={{ fontSize: Sizes.textSecondary, marginBottom: "10px" }} />
    <Skeleton variant="text" width={150} sx={{ fontSize: Sizes.textSecondary, marginBottom: "5px" }} />
    <Skeleton variant="text" width={350} sx={{ fontSize: Sizes.textSecondary, marginBottom: "10px" }} />
    <Box sx={{ ...FlexBoxInline, marginBottom: "10px" }}>
      <Skeleton variant="rectangular" width={90} height={40} />
      <Skeleton variant="rectangular" width={90} height={40} />
    </Box>
  </Box>


}

export default SchemaShimmer;
